import React from "react";

const ICON_STROKE = "currentColor";

export const SearchBarProductFilterIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 7L11 7" stroke={ICON_STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
      stroke={ICON_STROKE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M3 17L13 17" stroke={ICON_STROKE} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
      stroke={ICON_STROKE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const SearchBarAddShopIcon = ({ onClick }) => (
  <div
    className="svg-rec svg-rec-add"
    onClick={onClick}
    role="button"
    tabIndex={0}
    aria-label="افزودن مشتری"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19"
        stroke={ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M19 12H5"
        stroke={ICON_STROKE}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

export const VisitDateCalendarIcon = (props) => (
  <svg
    onClick={props.openCalendar}
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="visit-date-calendar-icon"
    role="button"
    aria-label="انتخاب تاریخ"
  >
    <path
      d="M19 13V16"
      stroke={ICON_STROKE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M27 13V16"
      stroke={ICON_STROKE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.5 20.0898H31.5"
      stroke={ICON_STROKE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14 24.01V19.5C14 16.5 15.5 14.5 19 14.5H27C30.5 14.5 32 16.5 32 19.5V28C32 31 30.5 33 27 33H19C15.5 33 14 31 14 28"
      stroke={ICON_STROKE}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M26.6947 24.7002H26.7037"
      stroke={ICON_STROKE}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M26.6947 27.7002H26.7037"
      stroke={ICON_STROKE}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19.6957 24.7002H19.7047"
      stroke={ICON_STROKE}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19.6957 27.7002H19.7047"
      stroke={ICON_STROKE}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
